import { cn, useTranslation } from '@/core'

interface FooterSectionProps {
  className?: string
}

export function FooterSection({ className }: FooterSectionProps) {
  const { t } = useTranslation()
  const currentYear = new Date().getFullYear()

  return (
    <footer className={cn('border-t border-gray-200 bg-white py-8', className)}>
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-center sm:text-left">
            <h3 className="font-bold text-gray-900">{t('app.title')}</h3>
            <p className="text-sm text-gray-600">{t('footer.internalUse')}</p>
          </div>
          <p className="text-sm text-gray-500">
            © {currentYear} {t('footer.allRights')}
          </p>
        </div>
      </div>
    </footer>
  )
}
